import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import moment from 'moment'
import ModalDialog from '../../../components/common/ModalDialog'
import SearchField from '../../../components/common/SearchField'
import DateTime from 'react-datetime'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'

import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tab,
  Tabs,
  List,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  Select,
  MenuItem,
  Radio,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  EditableSwitch,
  EditableReactSelectAsync,
  EditableReactSelectCreatable,
} from '../../../components/common/EditableComponents'
import { getRoles, fetchEmployeeById } from '../../../actions/employee'
import { convertDateToLongWithTimeZone } from '../../../utils/common'

import {
  getReportRequestList,
  getAvailableReports,
  getGeneratedReport,
  exportByReportType,
  getBroadcastDropdownsInfo,
  createBroadcast,
} from '../../../actions/insights'
import { searchEmployee } from '../../../actions/employee'

const daysoftheweek = [
  { value: 7, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
]

class InsightsExport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      availableReports: [],
      availableFrequencies: [],
      employees: [],
      selectedShops: [],
      employee: {},
      employeeId: null,
      showReportActionModal: false,
      reportType: '',
      time: 'today',
      startDate: '',
      endDate: '',
      email: '',
      viewSummaryButton: false,
      viewLowInventoryButton: false,
      sendReport: false,
      sendSummary: false,
      downloadingReport: false,
      summaryDate: moment().valueOf(),
      openBlazeInsights: false,
      loadingReports: false,
      reportExportProperties: {},
      broadcastDropdownsInfo: null,
      activeTab: 'Generated',
      exportTab: 'export',
      reports: [],
      date: 'TODAY',
      searchTerm: '',
      reportsOriginal: [],
      frequency: 'Daily',
      subscribers: [],
      externalEmail: false,
      subscriberEmailsExternal: [],
      frequencyDescription: '',
      subscriberIds: [],
      weeklyDay: 7,
      format: 2,
    }
  }

  getEmployeeById = (id) => {
    this.props
      .dispatch(fetchEmployeeById(id))
      .then((res) => this.setState({ employee: res, employeeId: res.id }))
  }

  async componentDidMount() {
    this.getEmployeeById(localStorage.getItem('apc_user_id'))
    this.props.dispatch(getRoles())
    this.setState({ loadingReports: true })
    this.props.dispatch(getReportRequestList()).then((res) => {
      this.setState({
        reports: res,
        reportsOriginal: res,
        loadingReports: false,
      })
    })
    this.props.dispatch(getAvailableReports()).then((res) => {
      this.setState({
        availableReports: new Map(Object.entries(res)),
        loadingReports: false,
      })
    })
    this.props.dispatch(getBroadcastDropdownsInfo()).then((res) => {
      this.setState({
        broadcastDropdownsInfo: res,
      })
    })
  }

  onVersionChanged = (version) => {
    this.setState({ version })
  }

  onFormatChanged = (format) => {
    this.setState({ format })
  }

  onSelectChange = (key, input, multiple = false) => {
    if (key === 'frequency' && !!input) {
      const { availableFrequencies = [] } = this.props
      const selectedFrequency =
        availableFrequencies.find((elem) => elem.frequency === input.value) || {}
      this.setState(() => ({
        frequencyDescription: selectedFrequency.description || '',
      }))
    }

    if (key === 'subscribers' && !!input) {
      let subscriberIds = input.map((item) => item.value)
      this.setState({
        subscriberIds: subscriberIds,
      })
      this.setState({
        subscribers: input,
      })
    }

    if (key === 'subscriberEmailsExternal' && !!input) {
      this.setState({
        subscriberEmailsExternal: input,
      })
    }

    if (key === 'dayoftheweek' && !!input) {
      let dayId = input.value
      this.setState({
        weeklyDay: dayId,
      })
    }
  }

  addExternalEmails = () => (event) => {
    event &&
      event.targety &&
      this.setState({
        externalEmail: event.target.checked,
      })
  }

  selectedEmails() {
    const { subscriberEmailsExternal = [] } = this.state
    if (subscriberEmailsExternal == null || subscriberEmailsExternal == undefined) {
      return []
    }
    if (subscriberEmailsExternal.length === 0) {
      return []
    }

    if (
      subscriberEmailsExternal.length > 0 &&
      !!subscriberEmailsExternal[0].label &&
      !!subscriberEmailsExternal[0].value
    ) {
      return subscriberEmailsExternal
    }
    let options =
      (subscriberEmailsExternal &&
        subscriberEmailsExternal.map((item) => {
          return {
            label: item,
            value: item,
          }
        })) ||
      []
    this.setState({
      subscriberEmailsExternal: options,
    })
    return options
  }

  selectedEmployees() {
    const { subscribers = [] } = this.state
    if (subscribers.length === 0) {
      return []
    }

    if (subscribers.length > 0 && !!subscribers[0].label && !!subscribers[0].value) {
      return subscribers
    }
    return this.convertToOptions(subscribers, 'name', 'id')
  }

  onChange = (key, value) => {
    this.setState((prevState) => ({
      selectedShops: value,
    }))
  }

  onChangeAllshops = () => (event) => {
    const allShops = JSON.parse(localStorage.getItem('session')).employeeShops || []
    const shops = allShops.filter((x) => x.appTarget === 'Retail')
    let updatedShops = []
    if (event.target.checked) {
      shops.map((shop) => {
        updatedShops = [...updatedShops, shop.id]
      })
    } else {
      updatedShops = []
    }
    this.onChange('selectedShops', updatedShops)
  }

  onChangeShops = (shopId) => (event) => {
    let updatedShops = [...this.state.selectedShops]
    if (event.target.checked) {
      updatedShops = [...updatedShops, shopId]
    } else {
      const shopIndex = updatedShops.findIndex((shop) => shop === shopId)
      updatedShops.splice(shopIndex, 1)
    }

    this.onChange('selectedShops', updatedShops)
  }

  renderListGroupV2 = (reports) => {
    return reports.map((reportItem, index) => {
      return (
        reportItem && (
          <List
            className="list-group-item"
            key={reportItem.displayName}
            data-cy="item-list-reports"
          >
            {reportItem.yellowfinIntegration || reportItem.reportGroup === 'Compliance' ? (
              <Button
                onClick={() => {
                  if (reportItem.allowExportReport || reportItem.reportGroup === 'Compliance') {
                    this.openExportModal()
                    this.setState({
                      showReportActionModal: true,
                      reportType: reportItem.reportType,
                      reportExportProperties: reportItem,
                    })
                  } else {
                    this.redirectToBlazeInsightsByReportType(reportItem.reportType)
                  }
                }}
              >
                {reportItem.displayName}
              </Button>
            ) : (
              <div>{reportItem.displayName}</div>
            )}
            {window.Appcues &&
              window.Appcues.track(`${reportItem.displayName} selected`, {
                reports: reportItem.reportType,
              })}
          </List>
        )
      )
    })
  }

  downloadReport = (request) => {
    this.setState({
      downloadingReport: true,
    })
    this.props
      .dispatch(getGeneratedReport(request.id))
      .then((res) => {
        if (res) {
          var link = document.createElement('a')
          const fileExtension = request.format || 'csv'
          const fileType = `application/${fileExtension}` || 'application/octet-stream'

          link.href = window.URL.createObjectURL(new Blob([res], { type: fileType }))

          link.setAttribute('download', `${request.asset.name.replace('.gz', '.' + fileExtension)}`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
        this.setState({
          downloadingReport: false,
        })
      })
      .catch((err) => {
        this.setState({
          downloadingReport: false,
        })
      })
  }

  onSearchShopeKey = () => {
    const reportRequests = this.state.reportsOriginal
    const { searchTerm = '' } = this.state
    const allShops = JSON.parse(localStorage.getItem('session')).employeeShops || []
    const filterRequests = reportRequests
      .map((request) => {
        let listOfShops = request.shopId.split(',')
        let shops = ''
        const numberOfShops = listOfShops.length
        for (let i = 0; i < numberOfShops; i++) {
          let idShop = listOfShops[i].replace(/'/g, '')
          let shop = allShops.filter((x) => x.appTarget === 'Retail' && x.id === idShop)
          let endString = i === numberOfShops - 1 ? '' : ', '
          shops = shop && shop.length > 0 && shops + shop[0].name + endString
          if (shops.toLowerCase().includes(searchTerm.toLowerCase())) {
            return request
          }
        }
      })
      .filter(function (x) {
        return x !== undefined
      })
    this.setState({ reports: filterRequests })
  }

  changeFrequency = () => (event) => {
    !!event &&
      this.setState({
        frequency: event.target.value,
      })
  }

  changeDayOfWeek = () => (event) => {
    !!event &&
      this.setState({
        weeklyDay: event.target.value,
      })
  }

  onChangeTerm = (event) => {
    this.setState({
      searchTerm: event && event.target && event.target.value ? event.target.value : '',
    })
  }

  getReportsGeneratedInformation = () => {
    const reportRequests = this.state.reports
    const employee = this.state.employee
    const { searchTerm = '' } = this.state
    const allShops = JSON.parse(localStorage.getItem('session')).employeeShops || []

    return (
      <Grid item container>
        <Grid item style={{ justifyContent: 'center', display: 'flex' }} xs={12}>
          <Grid className="list-container" item xs={6} sm={6} md={6} lg={6}>
            <SearchField
              onChange={this.onChangeTerm}
              value={searchTerm}
              onSearch={this.onSearchShopeKey}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ justifyContent: 'center', display: 'flex' }}>
          <Table style={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Request Date</TableCell>
                <TableCell>Report Type</TableCell>
                <TableCell>Shops</TableCell>
                <TableCell>Start Date</TableCell>
                <TableCell>End Date</TableCell>
                <TableCell>Requested By</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Download Link</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(reportRequests &&
                reportRequests != [] &&
                reportRequests.map((request) => {
                  let reportType
                  let listOfShops = request.shopId.split(',')
                  let shops = ''
                  const numberOfShops = listOfShops.length
                  for (let i = 0; i < numberOfShops; i++) {
                    let idShop = listOfShops[i].replace(/'/g, '')
                    let shop = allShops.filter((x) => x.appTarget === 'Retail' && x.id === idShop)
                    let endString = i === numberOfShops - 1 ? '' : ', '
                    shops = shop && shop.length > 0 && shops + shop[0].name + endString
                  }
                  if (request.reportType) {
                    if (request.reportType === 'CUSTOMER_SUBMISSION_EXPORT') {
                      reportType = 'RETAIL_SALES_BY_CCA_PRODUCT_TYPE'
                    } else {
                      if (request.reportName !== null && request.reportName !== undefined) {
                        reportType = request.reportName
                      } else {
                        reportType = request.reportType
                      }
                    }
                  }
                  return (
                    <Fragment>
                      <TableRow>
                        <TableCell>
                          {request.requestDate &&
                            moment(request.requestDate).format('MM/DD/YYYY HH:mm:SS')}
                        </TableCell>
                        <TableCell>{reportType && reportType.replace(/_/g, ' ')}</TableCell>
                        <TableCell>{shops}</TableCell>
                        <TableCell>
                          {(request.reqStartDate &&
                            moment(request.reqStartDate).format('MM/DD/YYYY HH:mm:SS')) ||
                            null}
                        </TableCell>
                        <TableCell>
                          {(request.reqEndDate &&
                            moment(request.reqEndDate).format('MM/DD/YYYY HH:mm:SS')) ||
                            null}
                        </TableCell>
                        <TableCell>
                          {employee && `${employee.firstName} ${employee.lastName}`}
                        </TableCell>
                        <TableCell>{request.status}</TableCell>
                        <TableCell>
                          <Button
                            onClick={() => {
                              if (request.status == 'Completed') {
                                this.downloadReport(request)
                              }
                            }}
                          >
                            Download
                          </Button>
                        </TableCell>
                      </TableRow>
                    </Fragment>
                  )
                })) ||
                null}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    )
  }

  changeActiveTab = (event, eventKey) => {
    this.setState({
      activeTab: eventKey,
    })
  }

  changeActiveExportTab = (event, eventKey) => {
    this.setState({
      exportTab: eventKey,
    })
  }

  openExportModal = () => {
    this.exportModal.handleClickOpen()
  }

  onConfirmExportModal = () => {
    let args = {
      ...this.state,
    }
    this.reportModalContinue(args)
  }

  onLoadingReports = () => {
    this.setState({
      loadingReports: true,
    })
  }

  refreshGeneratedSection = async () => {
    this.props.dispatch(getReportRequestList()).then((res) => {
      this.setState({
        reports: res,
        loadingReports: false,
      })
    })
  }

  reportModalContinue = async (args) => {
    const {
      date,
      startDate,
      endDate,
      reportExportProperties,
      selectedShops,
      subscriberEmailsExternal,
      subscribers,
      frequencyDescription,
      frequency,
      subscriberIds,
      weeklyDay,
      format = 2,
    } = args
    const reportType =
      reportExportProperties && reportExportProperties != {} && reportExportProperties.reportType
    if (selectedShops.length < 1) {
      this.props.dispatch(openErrorMessage('Error! Please select at least one shop to export'))
      this.exportModal.handleClose()
      return
    }
    this.onLoadingReports()
    let stringSelectedShops = selectedShops[0]
    for (var i = 1; i < selectedShops.length; i++) {
      stringSelectedShops += `','` + selectedShops[i]
    }
    
    const data = {
      id: null,
      reportType: reportType,
      frequencyDescription: 'This report will be delivered by the end of the day.',
      frequency: frequency,
      subscriberIds: subscriberIds,
      enable: true,
      description: '', //describe the frequency
      employee: '', //employee that creates the broadcast
      subscribers: subscribers, //list of employee objects
      weeklyDay: weeklyDay,
      multishop: true,
      subscriberEmailsExternal: subscriberEmailsExternal,
      listOfShops: stringSelectedShops,
      version: 2,
      finalFormat: format === 2 ? 'csv' : 'pdf',
    }
    if (!data.subscriberIds || data.subscriberIds == null || data.subscriberIds === '') {
      data.subscriberIds = []
    }
    if (
      data.subscriberEmailsExternal &&
      data.subscriberEmailsExternal !== null &&
      data.subscriberEmailsExternal.length > 0
    ) {
      let emails = data.subscriberEmailsExternal.map((subscriber) => subscriber.label)
      data.subscriberEmailsExternal = emails
    }
    this.state.exportTab === 'export' &&
      this.props
        .dispatch(
          exportByReportType(
            reportType,
            date,
            startDate,
            endDate,
            stringSelectedShops,
            2,
            format === 2 ? 'csv' : 'pdf',
          ),
        )
        .then((result) => {
          const { errorType = '', message } = result
          let splitErrorType = errorType.split('.')

          if (
            message &&
            splitErrorType &&
            splitErrorType.includes('BlazeReportGeneratedException')
          ) {
            this.props.dispatch(openSuccessMessage('Success! ' + message))
          }

          this.props.dispatch(getReportRequestList()).then((res) => {
            this.setState({
              reports: res,
              loadingReports: false,
            })
          })

          this.setState({
            loadingReports: false,
          })
          this.exportModal.handleClose()
        })
        .catch((error) => {
          this.setState({
            loadingReports: false,
          })
          this.exportModal.handleClose()
        })
    this.state.exportTab === 'broadcast' &&
      this.props.dispatch(createBroadcast(data)).then((result) => {
        this.props.dispatch(openSuccessMessage('Success ! Scheduled Report has been created.'))
        this.exportModal.handleClose()
      })
  }

  getPanelInformationV2 = (availableReports) => {
    let reportsAsList = []
    availableReports.forEach((value, key) => {
      reportsAsList = [...reportsAsList, key]
    })
    const { activeTab } = this.state
    return (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Paper>
          <Tabs value={activeTab} textColor="black" onChange={this.changeActiveTab} centered>
            {reportsAsList.map((reportName) => {
              return (
                <Tab //style={{textDecoration: (this.state.activeTab === 'Blaze Insights') ? 'underline solid rgb(70,196,233) 4px' : "none",  textUnderlineOffset: '15px'}}
                  label={reportName}
                  value={reportName}
                />
              )
            })}
            <Tab label="Generated" value="Generated" />
          </Tabs>
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            rowSpacing={2}
            columnSpacing={{ xs: 2, sm: 3, md: 4 }}
          >
            <Grid item xs={12}>
              {this.state.activeTab !== 'Generated' &&
                reportsAsList.map((reportGroup) => {
                  return (
                    reportGroup === activeTab &&
                    this.renderListGroupV2(availableReports.get(reportGroup))
                  )
                })}
              {this.state.activeTab === 'Generated' && this.getReportsGeneratedInformation()}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }

  onDateChanged = (key) => (event) => {
    let date = event.toDate()
    let assignedShop = JSON.parse(localStorage.getItem('session')).assignedShop
    let timezone = (assignedShop && assignedShop.timeZone) || 'GMT-5'
    if (moment(date).isValid()) {
      this.setState({
        [key]: convertDateToLongWithTimeZone(date, timezone),
      })
    }
  }

  changeDateState = () => (event) => {
    this.setState({
      date: event.target.value,
    })
  }

  convertToOptions = (array, key, value) => {
    return (
      (array &&
        array.map((item) => {
          return {
            label: item[key],
            value: item[value],
          }
        })) ||
      []
    )
  }

  loadEmployees = (term, callback) => {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0) {
      const { employees = [] } = this.props
      const options = this.convertToOptions(employees, 'name', 'id')
      callback(null, { options })
      return
    }

    this.timeout = setTimeout(() => {
      this.props.dispatch(searchEmployee(term)).then((res) => {
        let options = []
        options = res && res.values ? this.convertToOptions(res.values, 'name', 'id') : []
        callback(null, { options })
      })
    }, 500)
  }

  render() {
    const {
      availableReports,
      employee,
      reportExportProperties,
      date,
      selectedShops,
      broadcastDropdownsInfo,
      subscribers,
      subscriberEmailsExternal,
      frequency,
      version,
      format,
    } = this.state
    const { roles = [] } = this.props.employeeReducer || {}
    const allShops = JSON.parse(localStorage.getItem('session')).employeeShops || []
    const shops = allShops.filter((x) => x.appTarget === 'Retail')
    const data = employee
    const isComplianceReport =
      reportExportProperties &&
      reportExportProperties != {} &&
      reportExportProperties.reportGroup === 'Compliance'
    const showOneDateField =
      reportExportProperties &&
      reportExportProperties != {} &&
      reportExportProperties.showOneDateField
    const noShowDateField =
      reportExportProperties &&
      reportExportProperties != {} &&
      reportExportProperties.noShowDateField
    const showVersion =
      reportExportProperties && reportExportProperties != {} && reportExportProperties.showVersion
    //Only some reports
    const showPdfFormat =
      reportExportProperties && reportExportProperties != {} && reportExportProperties.showPdfFormat
    const datesOptions = [
      { value: 'TODAY', name: 'TODAY' },
      { value: 'YESTERDAY', name: 'YESTERDAY' },
      { value: 'WEEK', name: 'WEEK' },
      { value: 'MONTH', name: 'MONTH' },
      { value: 'CUSTOM', name: 'CUSTOM' },
    ]

    const { employees = [], frequencies = [] } = broadcastDropdownsInfo || {}
    const { companyFeatures = {} } = this.props.companyReducer || {}
    const showVersionCompanyLevel = companyFeatures && companyFeatures.showVersions
    const showPdfFormatCompanyLevel = companyFeatures && companyFeatures.showPdfFormat
    return (
      <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container xs={12} sm={12} md={12} lg={12} xl={12} style={{ width: '100%' }}>
          <Button
            style={{ backgroundColor: 'rgb(70,196,233)', color: 'white' }}
            onClick={this.refreshGeneratedSection}
          >
            Refresh Generated Reports
          </Button>
        </Grid>
        <ExpansionPanel className="margin-top-small" defaultExpanded={true} style={{ flexGrow: 1 }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="title" gutterBottom className="tab-heading">
              Selected shops
            </Typography>
          </ExpansionPanelSummary>
          <Grid className="editField" container style={{ padding: '0px 20px' }}>
            <Grid item alignItems="center" style={{ width: '100%' }}>
              <EditableSwitch editMode={true} onChange={this.onChangeAllshops()} />
              <strong>Add All Shops</strong>
            </Grid>
            {shops.map((shop) => {
              return (
                <Grid item md={4} alignItems="center" style={{ width: '100%' }} key={shop.id}>
                  <EditableSwitch
                    editMode={true}
                    onChange={this.onChangeShops(shop.id)}
                    checked={
                      !!(selectedShops && selectedShops.find((shopId) => shop.id === shopId))
                    }
                  />
                  {shop.name}
                </Grid>
              )
            })}
          </Grid>
        </ExpansionPanel>
        <Grid container className="margin-top-small">
          {availableReports !== null && this.getPanelInformationV2(availableReports)}
          {
            <ModalDialog ref={(c) => (this.exportModal = c)} onConfirm={this.onConfirmExportModal}>
              <Grid container xs={12} style={{ width: '100%' }}>
                <Grid item style={{ width: '100%' }}>
                  <Tabs
                    value={this.state.exportTab}
                    textColor="black"
                    onChange={this.changeActiveExportTab}
                    centered
                  >
                    <Tab label="Export Report" value="export" />
                    <Tab label="Create Broadcast" value="broadcast" />
                  </Tabs>
                  <Grid itemcontainer xs={12}>
                    {this.state.exportTab === 'export' && (
                      <Grid item style={{ width: '100%' }}>
                        <div style={{ width: '100%' }}>
                          <Grid item xs={6} lg={12} style={{ margin: '6px' }} />
                          {!noShowDateField && !isComplianceReport && (
                            <div>
                              <h4>Date</h4>
                              <Select
                                value={this.state.date}
                                MenuProps={{ className: 'no-backdrop-select' }}
                                style={{ minWidth: 200, marginLeft: 10 }}
                                onChange={this.changeDateState()}
                              >
                                {datesOptions.map((item, index) => {
                                  return (
                                    <MenuItem key={index} value={item.value}>
                                      {item.name}
                                    </MenuItem>
                                  )
                                })}
                              </Select>
                            </div>
                          )}
                          <Grid item xs={6} lg={12} style={{ margin: '4px' }} />
                          {!noShowDateField && (date === 'CUSTOM' || isComplianceReport) && (
                            <div id="insightsDatePickerContainer" style={{ display: 'flex' }}>
                              <Grid
                                className="insightsDatePicker"
                                item
                                xs={6}
                                sm={!showOneDateField ? 6 : 12}
                              >
                                <h4>{!showOneDateField ? 'From' : 'Date'}</h4>
                                <DateTime
                                  isValidDate={this.isValidDate}
                                  dateFormat="MM/DD/YYYY"
                                  onChange={this.onDateChanged('startDate')}
                                  inputProps={{ placeholder: 'MM/DD/YYYY' }}
                                  ref="datepicker"
                                  timeFormat={false}
                                  closeOnSelect={true}
                                />
                              </Grid>
                              {!showOneDateField && (
                                <Grid className="insightsDatePicker" item xs={6} sm={6}>
                                  <h4>To</h4>
                                  <DateTime
                                    isValidDate={this.isValidDate}
                                    dateFormat="MM/DD/YYYY"
                                    onChange={this.onDateChanged('endDate')}
                                    inputProps={{ placeholder: 'MM/DD/YYYY' }}
                                    ref="datepicker"
                                    timeFormat={false}
                                    closeOnSelect={true}
                                  />
                                </Grid>
                              )}
                            </div>
                          )}
                          {showPdfFormatCompanyLevel && showPdfFormat && (
                            <Grid item xs={12} style={{ marginTop: '15px' }}>
                              <Typography>
                                <strong>Format: </strong> <br />
                              </Typography>
                              <div>
                                <div style={{ display: 'inline-block' }}>
                                  <FormControlLabel
                                    control={
                                      <Radio
                                        value={2}
                                        checked={format === 2}
                                        onChange={() => this.onFormatChanged(2)}
                                      />
                                    }
                                    label="CSV"
                                  />
                                </div>
                                <div
                                  style={{
                                    display: 'inline-block',
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Radio
                                        value={1}
                                        checked={format === 1}
                                        onChange={() => this.onFormatChanged(1)}
                                      />
                                    }
                                    label="PDF"
                                  />
                                </div>
                              </div>
                            </Grid>
                          )}
                        </div>
                      </Grid>
                    )}
                    {this.state.exportTab === 'broadcast' && (
                      <Grid item style={{ width: '100%' }}>
                        <div style={{ width: '100%' }}>
                          <Grid item xs={6} lg={12} style={{ margin: '6px' }} />
                          {!isComplianceReport && (
                            <div>
                              <h4>Frequency</h4>
                              <Select
                                value={this.state.frequency}
                                MenuProps={{ className: 'no-backdrop-select' }}
                                style={{ minWidth: 200, marginLeft: 10 }}
                                onChange={this.changeFrequency()}
                              >
                                {frequencies.map((item, index) => {
                                  return (
                                    <MenuItem key={index} value={item.frequency}>
                                      {item.frequency}
                                    </MenuItem>
                                  )
                                })}
                              </Select>
                            </div>
                          )}
                          {frequency === 'Weekly' && (
                            <div>
                              <h4>Day of Week</h4>
                              <Select
                                value={this.state.weeklyDay}
                                MenuProps={{ className: 'no-backdrop-select' }}
                                style={{ minWidth: 200, marginLeft: 10 }}
                                onChange={this.changeDayOfWeek()}
                              >
                                {daysoftheweek.map((item, index) => {
                                  return (
                                    <MenuItem key={index} value={item.value}>
                                      {item.label}
                                    </MenuItem>
                                  )
                                })}
                              </Select>
                            </div>
                          )}
                          <h4>Subscribers</h4>
                          <EditableReactSelectAsync
                            multi={true}
                            clearable={true}
                            valueToRender={
                              subscribers &&
                              subscribers
                                .map((subscriber) => subscriber.name || subscriber.label || '--')
                                .join(', ')
                            }
                            onChange={(data) => this.onSelectChange('subscribers', data, true)}
                            loadOptions={this.loadEmployees}
                            value={this.selectedEmployees()}
                            editMode={true}
                            autoload={false}
                            onBlurResetsInput={false}
                            portalPlacement={'bottom'}
                            options={this.convertToOptions(employees, 'name', 'id')}
                            noResultsText={'No employees found'}
                          />
                          <Grid item alignItems="center" style={{ width: '100%' }}>
                            <h4>Send to external email(s)</h4>
                            {true && (
                              <EditableReactSelectCreatable
                                multi={true}
                                clearable={true}
                                valueToRender={
                                  subscriberEmailsExternal &&
                                  subscriberEmailsExternal
                                    .map(
                                      (subscriber) =>
                                        subscriber.label || subscriber.value || subscriber || '--',
                                    )
                                    .join(', ')
                                }
                                onChange={(data) =>
                                  this.onSelectChange('subscriberEmailsExternal', data, true)
                                }
                                value={this.selectedEmails()}
                                editMode={true}
                                autoload={false}
                                onBlurResetsInput={false}
                                portalPlacement={'bottom'}
                                options={this.convertToOptions(employees, 'email', 'id')}
                                noResultsText={'No employees found'}
                              />
                            )}
                          </Grid>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </ModalDialog>
          }
        </Grid>
      </Grid>
    )
  }
}

const ReportingBroadcastWithTitle = ContainerWithTitleWrapper(InsightsExport, 'Company Data Export')
const ReportingBroadcastConnected = connect(
  ({ shopReducer, dispatch, authReducer, employeeReducer, companyReducer }) => ({
    shopReducer,
    dispatch,
    authReducer,
    employeeReducer,
    companyReducer,
  }),
)(ReportingBroadcastWithTitle)

export default ReportingBroadcastConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Insights/InsightsExport.js